import { PoblacionReadingDtoProps } from "./DTOs/PoblacionReadingDto"

export function getPoblacionAdapter(
  poblacion: PoblacionReadingDtoProps
): PoblacionReadingDtoProps {
  return {
    id: poblacion.id,
    codigosPostales: poblacion.codigosPostales,
    nombre: poblacion.nombre,
    provinciaId: poblacion.provinciaId,
    provinciaNombre: poblacion.provinciaNombre,
  }
}
